<div class="ktbl-row-mehrspaltig-2-elemente">
  <div class="ktbl-flex-item" id="content_daten_9"></div>
  <div class="ktbl-flex-item" id="content_daten_10"></div>
</div>
